import { useCallback, useEffect, useState } from "react";

export type Theme = "light" | "dark" | "system";

const THEME_KEY = "educon-assistant-theme";

function readStored(): Theme {
  const v = localStorage.getItem(THEME_KEY);
  return v === "light" || v === "dark" || v === "system" ? v : "system";
}

function apply(theme: Theme): void {
  document.documentElement.setAttribute("data-theme", theme);
}

/** Tema da UI: claro / escuro / sistema, persistido em localStorage. */
export function useTheme() {
  const [theme, setThemeState] = useState<Theme>(() => {
    const t = readStored();
    apply(t);
    return t;
  });

  useEffect(() => {
    apply(theme);
  }, [theme]);

  const setTheme = useCallback((t: Theme) => {
    localStorage.setItem(THEME_KEY, t);
    setThemeState(t);
  }, []);

  /** Alterna entre os três modos na ordem sistema → claro → escuro. */
  const cycleTheme = useCallback(() => {
    setThemeState((prev) => {
      const next: Theme = prev === "system" ? "light" : prev === "light" ? "dark" : "system";
      localStorage.setItem(THEME_KEY, next);
      return next;
    });
  }, []);

  return { theme, setTheme, cycleTheme };
}
